import { request } from '../request';

/**
 * Login
 *
 * @param username User name
 * @param password Password
 */
export function fetchLogin(username: string, password: string) {
  return request<Api.Auth.LoginResponse>({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  });
}

/**
 * Verify TOTP
 *
 * @param tempToken Temporary token
 * @param totpCode TOTP code
 */
export function fetchVerifyTotp(tempToken: string, totpCode: string) {
  return request<Api.Auth.TotpVerifyResponse>({
    url: '/admin/verify-totp',
    method: 'post',
    data: {
      temp_token: tempToken,
      totp_code: totpCode
    }
  });
}

/** Get user info */
export function fetchGetUserInfo() {
  return request<{
    code: number;
    msg: string;
    data: Api.Auth.UserInfo;
  }>({ url: '/admin/profile' });
}

/**
 * Refresh token
 *
 * @param refreshToken Refresh token
 */
export function fetchRefreshToken(refreshToken: string) {
  return request<Api.Auth.LoginToken>({
    url: '/admin/refresh-token',
    method: 'post',
    data: {
      refresh_token: refreshToken
    }
  });
}

/** Logout */
export function fetchLogout() {
  return request<{
    code: number;
    msg: string;
  }>({
    url: '/admin/logout',
    method: 'post'
  });
}

/**
 * return custom backend error
 *
 * @param code error code
 * @param msg error message
 */
export function fetchCustomBackendError(code: string, msg: string) {
  return request({ url: '/auth/error', params: { code, msg } });
}
